import React, { forwardRef } from 'react';
import SearchInput from './SearchInput';
import { ReactComponent as Search } from 'assets/icons/search.svg';
import { twMerge } from 'tailwind-merge';

interface SearchInputBlockProps {
  testID?: string;
  handleOnChange: (value: string) => void;
  placeholder?: string;
  inputClassName?: string;
  className?: string;
  withFilter?: boolean;
}

const SearchInputBlock = forwardRef(
  (
    {
      handleOnChange,
      placeholder,
      testID = 'search',
      className,
      inputClassName,
      withFilter = true,
    }: SearchInputBlockProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
    return (
      <div
        className={twMerge(
          'relative flex items-center w-full desktop:max-w-[660px] desktop:mt-0',
          withFilter && 'max-xs:!w-[75%]',
        )}
      >
        <SearchInput
          testID={testID}
          handleOnChange={handleOnChange}
          placeholder={placeholder}
          inputClassName={inputClassName}
          className={twMerge('pl-7 w-full', className)}
          ref={ref}
        />
        <Search className="absolute top-1/2 -translate-y-1/2 left-0 w-[40px] fill-med-gray-3" />
      </div>
    );
  },
);

export default SearchInputBlock;
